//子表函数--23个
export const AnalyticalFunc = [
  {
    "key": "SortChildData",
    "name": "SortChildData",
    "params": [
      {
        "key": "setName",
        "name": "Subtable",
        "type": "string"
      },
      {
        "key": "propName",
        "name": "Sort Field",
        "type": "string"
      },
      {
        "key": "order",
        "name": "Sort by",
        "type": "string"
      }
    ],
    "description": `[Function] Sort subtable data (all parameters are wrapped with "")
    [parameter]
      [setName] child table (chain structure)
      [propName] Sort field (field type should be numeric type)
      [order] Sorting method ("ESC" means positive order from small to big, "DESC" means reverse order from big to small)
    [Return value] None
    [Example]
      [Scenario] Submit the document Order, the document contains the travel details sub-table trips, and the sub-table contains the travel expense money field
      [Requirement] Sort the sub-tables from small to large according to the travel expense money field
      [Example]SortChildData("Order.trips","money","ESC")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IncludedInList",
    "name": "IncludedInList",
    "params": [
      {
        "key": "propName",
        "name": "propName",
        "type": "object"
      },
      {
        "key": "list",
        "name": "datalists",
        "type": "list"
      }
    ],
    "description": `[Function]: Determine whether the field exists in the data list. Returns true if the field exists in the list, and returns false if it does not exist. Support for judging character and number types. \n[propName] table property (chain structure)\n[list] data list\n[return value type]: Boolean (Boolean)\n[Example]: IncludedInList(Order.name,["Zs","Ls"])\n[Example]: IncludedInList(Order.quantity,[100,200])`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ExistData",
    "name": "ExistData",
    "params": [
      {
        "key": "propName",
        "name": "property",
        "type": "string"
      }
    ],
    "description": `[Function]: Determine whether there is data in the sub-table. If there is data, it returns true, and if there is no data, it returns false. (All parameters are wrapped with "")\n[propName]Sub-table properties (chain structure)\n[Return value type]: Boolean (Boolean)\n[Example]: ExistData("Order.OrderItems")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "SumByProp",
    "name": "SumByProp",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      }
    ],
    "description": `[Function]: Count the sum of all the data in the sub-table for a certain attribute (all parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[return value type]: numeric value (Double)\n[Example]: SumByProp("Order.OrderItems","Quantity")"`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "CountByProp",
    "name": "CountByProp",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      }
    ],
    "description": `[Function]: Count the number of records of all data in the sub-table where a certain attribute is not null (all parameters are wrapped with "") [setName] Sub-table properties of the main table (chain structure) [propName] Sub-table properties [Return value Type]: Number (Int32);\n[Example]:CountByProp("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "AvgByProp",
    "name": "AvgByProp",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      }
    ],
    "description": `[Function]: Count the average value of a certain numeric attribute of all data in the sub-table (all parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[return value type] : Value (Double)\n[Example]: AvgByProp("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MaxByProp",
    "name": "MaxByProp",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      }
    ],
    "description": `[Function]: Return the maximum value of a certain numeric attribute of all data in the sub-table (all parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[return value type] : Numerical value (Double)\n[Example]: MaxByProp("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MinByProp",
    "name": "MinByProp",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      }
    ],
    "description": `[Function]: Return the minimum value of a certain numeric attribute of all data in the sub-table (all parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[return value type] : Numerical value (Double)\n[Example]: MinByProp("Order.OrderItems","Quantity")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNull",
    "name": "IsNull",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Judge whether the detection object is a null value (null) \n[Return value type]: Boolean value (Boolean)\n [Example]: IsNull("semantic expression") [Return value]: False`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNullOrWhiteSpace",
    "name": "IsNullOrWhiteSpace",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Determine whether the detection object is null, empty or only composed of spaces \n[Return value type]: Boolean value (Boolean)\n [Example]: IsNullOrWhiteSpace("semantic expression") [Return value]: False [example]: IsNullOrWhiteSpace(null) [return value]: True [example]: IsNullOrWhiteSpace(" ") [return value]: True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNaN",
    "name": "IsNaN",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Determine whether the detection object can be converted into a number (Double) \n[Return value type]: Boolean value (Boolean)\n [Example]: IsNaN("semantic expression") [Return value]: True [Example ]: IsNaN(12.3) [Return value]: False [Example]: IsNaN("123") [Return value]: False`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsNumber",
    "name": "IsNumber",
    "params": [
      {
        "key": "obj",
        "name": "obj",
        "type": "object"
      }
    ],
    "description": `[Function]: Determine whether the detection object can be converted into a number (Double) \n[Return value type]: Boolean (Boolean)\n [Example]: IsNumber("semantic expression") [Return value]: False [Example ]: IsNumber(12.3) [return value]: True [example]: IsNumber("123") [return value]: True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "IsExistRecord",
    "name": "IsExistRecord",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      },
      {
        "key": "match",
        "name": "match",
        "type": "string"
      }
    ],
    "description": `[Function]: Determine whether an attribute in all data of the sub-table has a value equal to the matching character (all parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[match ] Matching value \n[Return value type]: Boolean value (Boolean)\n [Example]: IsExistRecord("salesorder.items", "code", "lc") [Return value]: False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListGreaterThan",
    "name": "ListGreaterThan",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      },
      {
        "key": "match",
        "name": "match",
        "type": "double"
      }
    ],
    "description": `[Function]: Determine whether an attribute in all data of the sub-table has a value greater than the matching character (the first two parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[Match] Match value \n[Return value type]: Boolean value (Boolean)\n [Example]: ListGreaterThan("salesorder.items", "num", 100) [Return value]: False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListLessThan",
    "name": "ListLessThan",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      },
      {
        "key": "match",
        "name": "match",
        "type": "double"
      }
    ],
    "description": `[Function]: Determine whether an attribute in all data of the sub-table has a value less than the matching character (the first two parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[Match] Match value \n[Return value type]: Boolean value (Boolean)\n [Example]:ListLessThan("salesorder.items", "num", 100) [Return value]: False/True`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListStartWith",
    "name": "ListStartWith",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      },
      {
        "key": "match",
        "name": "match",
        "type": "string"
      }
    ],
    "description": `[Function]: Determine whether a certain attribute in all data of the sub-table has a value with a matching character at the beginning (all parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[ match] Matching value \n[Return value type]: Boolean value (Boolean)\n [Example]: ListStartWith("salesorder.items", "code", "lc") [Return value]: False/True `,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ListEndWith",
    "name": "ListEndWith",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      },
      {
        "key": "match",
        "name": "match",
        "type": "string"
      }
    ],
    "description": `[Function]: Determine whether an attribute in all data of the sub-table exists and ends with a matching character value (all parameters are wrapped with "") \n[setName] Sub-table attribute of the main table (chain structure) \n[propName] Sub-table attribute \n[match] match value \n[return value type]: Boolean value (Boolean)\n[example]: ListEndWith("salesorder.items", "code", "lc") [return value]: False/True `,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetSessionValue",
    "name": "GetSessionValue",
    "params": [
      {
        "key": "name",
        "name": "name",
        "type": "string"
      }
    ],
    "description": `[Function]: Get the value of the user session variable \n[name]: The name of the session variable \n[Return value type]: Object (Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetContextParameter",
    "name": "GetContextParameter",
    "params": [
      {
        "key": "name",
        "name": "name",
        "type": "string"
      }
    ],
    "description": `[Function]: Get the value of the context variable \n[name]: The name of the context variable \n[Return value type]: Object (Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "getComputeJsonData",
    "name": "getComputeJsonData"
  },
  {
    "key": "GetComputeJsonData",
    "name": "GetComputeJsonData",
    "params": [
      {
        "key": "chainedPropName",
        "name": "chainedPropName",
        "type": "string"
      },
      {
        "key": "propertyName",
        "name": "propertyName",
        "type": "string"
      }
    ],
    "description": `[Function]: Get the value of a certain attribute of all data in the sub-table and return it in the form of a JSON string (all parameters are wrapped with "") \n[setName] the sub-table attribute of the main table (chain structure) \n[propName] the sub-table attribute \n[Return value type]: Object (String) [Return value example]: [11,22,33]`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetInjectedEntity",
    "name": "GetInjectedEntity",
    "params": [
      {
        "key": "objName",
        "name": "objName",
        "type": "string"
      }
    ],
    "description": `[Function]: Get the actual object of the object injected at runtime (parameters are wrapped with ""), does not support getting properties \n[objName] injection name \n[return value type]: object (Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "GetChainedPropertyValue",
    "name": "GetChainedPropertyValue",
    "params": [
      {
        "key": "propName",
        "name": "propName",
        "type": "string"
      }
    ],
    "description": `[Function]: Get the actual value of the injected property at runtime (parameters are wrapped with "") \n[propName] property (chain structure) \n[Return value type]: Object (Object)`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "MultiplyChildNumber",
    "name": "MultiplyChildNumber",
    "params": [
      {
        "key": "childTable",
        "name": "childTable",
        "type": "string"
      },
      {
        "key": "prop1",
        "name": "property1",
        "type": "string"
      },
      {
        "key": "prop2",
        "name": "property2",
        "type": "string"
      }
    ],
    "description": `[Function] For the two numeric type attributes of the subtable, first do the product, and then sum (all parameters are wrapped with "")
[Parameter]
  [Table] 
  [table] Subtable properties in the main table (chain structure)
  [prop1] Attribute one (the type should be a numeric type)
  [prop2] Attribute two (the type should be a numeric type)
[ReturnType] number
[Example]
  [Scenes] Submit the document 'Order', the document contains the travel details sub-table 'trips', and the sub-table contains the business trip 'days' and travel expenses 'money'
  [Requirement] Get the total cost of travel details, that is, the sum of the sub-table travel days * travel expenses
  [Demo] MultiplyChildNumber("Order.trips","days","money")`,
    "type": "Analytical",
    "keyFront": "DefaultFunction",
    "className": ""
  },
  {
    "key": "ParseEnum",
    "name": "ParseEnum",
    "params": [
      {
        "key": "name",
        "name": "name",
        "type": "string"
      },
      {
        "key": "map",
        "name": "map",
        "type": "obj"
      },
    ],
    "description": `[Function]: Resolve enumeration to display value [Return value type]: number or string  n [Example]: ParseEnum(SysApproval.version, Enum.SysApproval.version)== 'Pass' [Return value]："true"`,
    "type": "Special",
    "keyFront": "DefaultFunction",
    "className": ""
  }
]